module.exports = __webpack_public_path__ + "img/jili1.8df24eb9.png";